import { useCallback } from 'react'

import { useMutation, useQueryClient } from 'react-query'

import { restrictedWordsService } from '@/modules/restricted-words/service/restricted-words-service.ts'

interface ToggleParams {
  wordId: number
  disabled: boolean
  overriddenBlockAllCombination?: boolean
}

export function useOverrideRestrictedWord() {
  const queryClient = useQueryClient()

  const overrideMutation = useMutation(
    ({ wordId, disabled, overriddenBlockAllCombination }: ToggleParams) =>
      restrictedWordsService.overrideRestrictedWord(
        wordId,
        disabled,
        overriddenBlockAllCombination,
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['restrictedWords'])
      },
    },
  )

  const overrideRestrictedWord = useCallback(
    (params: ToggleParams) => {
      return overrideMutation.mutateAsync(params)
    },
    [overrideMutation],
  )

  return {
    overrideRestrictedWord,
    isOverrideRestrictedWordLoading: overrideMutation.isLoading,
  }
}
